import { UserAcademicHistoryBase } from "domain/model/base";

export default class UserAcademicHistory extends UserAcademicHistoryBase {};
